// import { SurveySessionStatus } from '@hyper-inferno/survey-bot-core';
// Duplicate of SurveySessionStatus
export enum SessionStatusBot {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  TERMINATED = 'terminated',
  EXPIRED = 'expired',
}

export enum SubmissionTypes {
  CLIENT_RESPONSE = 'client-response',
  BOT_AUTO_CODE = 'bot-auto-code',
  CLIENT_PARAM_URL = 'client-url-param',
  CLIENT_SYSTEM = 'client-system',
  BOT_SYSTEM = 'bot-system',
  BOT_TERMINATE_SURVEY_NO_REDIRECT = 'bot-terminate-survey-no-redirect',
  BOT_TERMINATE_SURVEY_WITH_REDIRECT = 'bot-terminate-survey-with-redirect',
  CLIENT_AUTO_ADVANCE = 'client-auto-advance',
  CONVERSATION = 'conversation',
}

export interface SubmissionInfo {
  submissionType: SubmissionTypes;
  submissionPayload: {
    // Pass the URL into the payload so the UI knows where to go
    redirect_url?: string;
    sys_disposition_code?: string;
    ending_text?: string;
  };
  statusChange?: SessionStatusBot;
}

export type ResponseRecord = QuestionAnswerObject;

// export type QuestionAnswerObject = {
//   [key: string]: string | number | boolean | object | undefined;
// };

export type QuestionAnswerObject = {
  [key: string]: string | number | number[] | undefined;
};
